import { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_RECOMMENDATIONS } from '../queries';
import { FIRST_ORDER_GIFT } from '../constants';

export const useProductsRecommendations = (
  eventType: string,
  placement: string,
  visitorId: any,
  skus?: string[],
) => {
  const [products, setProducts] = useState<any[]>([]);

  const [getRecommendations, { data, loading }] = useLazyQuery(
    GET_RECOMMENDATIONS,
    {
      ssr: false,
      fetchPolicy: 'cache-and-network',
    },
  );

  useEffect(() => {
    getRecommendations({
      variables: {
        skus,
        visitorId,
        eventType,
        placement,
      },
    });
  }, []);

  useEffect(() => {
    if (data?.getRecommendationsV2) {
      setProducts(
        data?.getRecommendationsV2
          .filter(
            ({ tags }) => !tags.some((tag: string) => tag === FIRST_ORDER_GIFT),
          )
          .map((product: any) => {
            return {
              objectID: product.variantId,
              ...product,
              meta: {
                finance: {
                  unit_of_measurement: product.metafields.find(
                    (metafield) => metafield.key === 'unit_of_measurement',
                  )?.value,
                  unit_price: product.metafields.find(
                    (metafield) => metafield.key === 'unit_price',
                  )?.value,
                  product_format: product.metafields.find(
                    (metafield) => metafield.key === 'product_format',
                  )?.value,
                },
              },
            };
          }),
      );
    }
  }, [data?.getRecommendationsV2]);

  return { products, loading };
};
